import { useEffect, useState } from 'react';
import { AmbErrorProviderWeb3 } from '@airdao/airdao-node-contracts';
import { Contracts as PeripheryContracts } from '@airdao/bond-periphery';
import { ethers } from 'ethers';

import BondPeripheryContext from './context';
import { useAccount } from 'wagmi';
import { useEthersAdapter } from '@airdao/ui-library';

export default function BondPeripheryContextProvider(props: any) {
  const [contracts, setContracts] = useState<PeripheryContracts | null>(null);
  const { isConnected: isActive, chainId } = useAccount();
  const { provider } = useEthersAdapter();

  useEffect(() => {
    (async () => {
      let providerOrSigner;
      if (isActive && provider?.provider) {
        const errorProvider = new AmbErrorProviderWeb3(provider?.provider);
        providerOrSigner = errorProvider.getSigner();
      } else {
        providerOrSigner = new ethers.providers.JsonRpcProvider(
          process.env.REACT_APP_RPC_URL,
        );
      }

      const initializedPeripheryContracts = new PeripheryContracts(
        providerOrSigner,
        BigInt(process.env.REACT_APP_CHAIN_ID || 30746),
      );

      setContracts(initializedPeripheryContracts);
    })();
  }, [isActive, chainId, provider?.provider]);

  // const value = useMemo(() => (contracts), [contracts]);

  return <BondPeripheryContext.Provider value={contracts} {...props} />;
}
